import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { autoinject } from "aurelia-framework";

/**
 * A general custom element.
 */
export interface ICustomElement {
    element: Element;
}

@autoinject()
/**
 * Base class for general custom elements.
 */
export abstract class CustomElementBase implements ICustomElement {
    public readonly element: HTMLElement;
    constructor(element: Element, protected readonly logger: AppLogger) {
        this.element = element as HTMLElement
    }
}
